export default __webpack_public_path__ + "static/square_b.307052f715f2966efcb3d33d0925f509.svg";